import MainHeader from '../../layouts/MainHeader';
import environmentPageData from '../../data/english/environment-page-data';
import BorderLeftBox from '../../components/boxes/BorderLeftBox';
import SecondaryCard from '../../components/cards/SecondaryCard';
import TextAndImageSection from '../../components/sections/TextAndImageSection';
import HighlighCard from '../../components/cards/HighlightCard';
import FlexViewTwo from '../../components/FlexView/FlexViewTwo/FlexViewTwo';
import ColTwo from '../../components/FlexView/ColTwo';
import Footer from '../../layouts/Footer';
import DarkSection from '../../components/sections/ColoredSection/DarkSection';
import Separator from '../../components/Separator';
import TitleBorderLeft from '../../components/Text/TitleBorderLeft';
import HorizontalChart from '../../components/Charts/HorizontalChart';
import ChartTwo from '../../components/Charts/ChartTwo';
import TitleSection from '../../components/sections/TitleSection';
import ChartThree from '../../components/Charts/ChartThree/ChartThree';

const EnvironmentPage = () => {
  return (
      <main id="main" className='page'>
      <div className='sticky-view-two'>
        <div className="sticky-container">
          <MainHeader 
            title=""
            image={{
              src : require(`../../assets/images/wallpaper/${environmentPageData.header.image.name}`),
              alt : environmentPageData.header.image.alt,
            }}
          />
        </div>
        <div className="sticky-container-two" id="mainContent">
          
          <div className="wrapper-small">
            <h1 className="title-center">{environmentPageData.sectionOne.title}</h1>
            <BorderLeftBox 
              title={environmentPageData.sectionOne.borderBox.title}
              subtitle={environmentPageData.sectionOne.borderBox.subtitle}
            />
            <p className="text-paragraph">{environmentPageData.sectionOne.paraghraphOne}</p>
            <p className="text-paragraph">{environmentPageData.sectionOne.paraghraphTwo}</p>
            <p className="text-paragraph">{environmentPageData.sectionOne.paragraphThree}</p>
            <p className="text-paragraph">{environmentPageData.sectionOne.paragraphFour}</p>
          </div>
          <div className='space-50'></div>
          <TitleSection 
            title={environmentPageData.centerTitle}
          />
          {
          environmentPageData.sectionTow.map((item, index) => (
            <SecondaryCard
              key={index}
              title={item.title}
              subtitle={item.subtitle}
              icon={{
                name : require(`../../assets/icons/environment/${item.icon}`),
                alt : ""
              }}
            />
          ))
          }
          <div className="wrapper-small">
            <div className="space-50"></div>
            <p className="text-paragraph">{environmentPageData.subsection.paragraphOne}</p>
            <p className="text-paragraph">{environmentPageData.subsection.paragraphTwo}</p>
            <BorderLeftBox 
              title={environmentPageData.subsection.borderLeftBox.title}
              subtitle={environmentPageData.subsection.borderLeftBox.subtitle}
            />
            <div className='space-50'></div>
          </div>
          {/* <Separator /> */}
          {/* <div className='wrapper-larg'>
            <TextAndImageSection 
              title={environmentPageData.sectionThree.title}
              image={{
                src : require('../../assets/images/backgrounds/sustainable-project.jpg'),
                alt : environmentPageData.sectionThree.image.alt
              }}
            />
          </div>
          {environmentPageData.sectionFour.map((item, index) => (
            <SecondaryCard 
              key={index}
              title={item.title}
              subtitle={item.subtitle}
              icon={{
                name : require(`../../assets/icons/environment/${item.icon}`),
                alt : ""
              }}
            />
          ))}
          <div className="space-50"></div>
          <div className="space-50"></div>
          <div className='wrapper-small'>
            <BorderLeftBox 
              title={environmentPageData.sectionFive.borderBox.title}
              subtitle={environmentPageData.sectionFive.borderBox.subtitle}
            />
            <p className="text-paragraph">
              {environmentPageData.sectionFive.paragraphOne}
            </p>
            <div className="table-wrapper">
            <table className="table-secondary">
              <thead>
                <tr aria-hidden="true"></tr>
                <tr>
                  <th>{environmentPageData.sectionFive.tableOne.headers[0]}</th>
                </tr>
              </thead>
            </table>
            <p className="text-note">SAB’s green deposit allows customers to safely deposit their money towards green financing initiatives, with these client funds generating competitive returns for short to medium-term investments.</p>
            <table className="table-secondary">
              <tbody>
                {
                environmentPageData.sectionFive.tableOne.data.map((item, index) => (
                  <tr key={index}>
                    <td className="mnw-200"><b>{item[0]}</b></td>
                    <td>{item[1]}</td>
                  </tr>
                ))
                }
              </tbody>
            </table>
            </div>
            <BorderLeftBox 
              title={environmentPageData.sectionFive.borderBoxTwo.title}
              subtitle={environmentPageData.sectionFive.borderBoxTwo.subtitle}
            />
          </div> */}
          <div className="space-50"></div>
          <Separator />
          <div className="space-50"></div>
          <div className="wrapper-small">
            <h2 className="text-title">{environmentPageData.sectionSix.title}</h2>
            <TitleBorderLeft>{environmentPageData.sectionSix.titleBorderLeft}</TitleBorderLeft>
            <p className='text-paragraph'>{environmentPageData.sectionSix.paragraphOne}</p>
            <p className='text-paragraph'>{environmentPageData.sectionSix.paragraphTwo}</p>
            <p className='text-paragraph'>{environmentPageData.sectionSix.paragraphThree}</p>
            <p className='text-paragraph'>{environmentPageData.sectionSix.paragraphFour}</p>
            {/* <div className='space-50'></div> */}
            <TitleBorderLeft>{environmentPageData.sectionSix.chartOneSection.title}</TitleBorderLeft>
            <HorizontalChart 
              colGroups={environmentPageData.sectionSix.chartOneSection.chart.data}
              labels={environmentPageData.sectionSix.chartOneSection.chart.labels}
              xAxis={environmentPageData.sectionSix.chartOneSection.chart.xAxis}
            />
            <div className="space-50"></div>
            <div className="space-50"></div>
            <TitleBorderLeft>{environmentPageData.sectionSix.chartSectionTwo.title}</TitleBorderLeft>
            <div className="chart-flex-view">
              <ChartTwo 
                cols={environmentPageData.sectionSix.chartSectionTwo.chartOne.cols}
                maxValue={environmentPageData.sectionSix.chartSectionTwo.chartOne.maxValue}
                xAxis={environmentPageData.sectionSix.chartSectionTwo.chartOne.xAxis}
                title={environmentPageData.sectionSix.chartSectionTwo.chartOne.title}
              />
              <ChartTwo 
                cols={environmentPageData.sectionSix.chartSectionTwo.chartTwo.cols}
                maxValue={environmentPageData.sectionSix.chartSectionTwo.chartTwo.maxValue}
                xAxis={environmentPageData.sectionSix.chartSectionTwo.chartTwo.xAxis}
                title={environmentPageData.sectionSix.chartSectionTwo.chartTwo.title}
              />
              <ChartTwo 
                cols={environmentPageData.sectionSix.chartSectionTwo.chartThree.cols}
                maxValue={environmentPageData.sectionSix.chartSectionTwo.chartThree.maxValue}
                xAxis={environmentPageData.sectionSix.chartSectionTwo.chartThree.xAxis}
                title={environmentPageData.sectionSix.chartSectionTwo.chartThree.title}
              />
            </div>
          </div>
          <div className="space-50"></div>
          <div className="space-50"></div>
          <div className="wrapper-small">
            <TitleBorderLeft>{environmentPageData.sectionSeven.borderTitleOne}</TitleBorderLeft>
            <div className="space-50"></div>
            {environmentPageData.sectionSeven.subSections.map((item, index) => (
              <>
              <h4 key={index} className="text-title-medium">{item.title}</h4>
              <p key={index} className="text-paragraph">{item.subtitle}</p>
              </>
            ))}
            {/* <TitleBorderLeft>{environmentPageData.sectionSeven.borderTitleTwo}</TitleBorderLeft>
            <p className="text-paragraph">{environmentPageData.sectionSeven.paragraphOne}</p> */}
          </div>
          <div className="space-50"></div>
          <Separator />
          <div className="space-50"></div>
          <div className="wrapper-small">
            <div className="text-title">{environmentPageData.sectionSevent.title}</div>
            <p className="text-paragraph">{environmentPageData.sectionSevent.paragraphOne}</p>
            <TitleBorderLeft>{environmentPageData.sectionSevent.borderTitle}</TitleBorderLeft>
            {/* <img
              src={require(`../../assets/images/plans/${environmentPageData.sectionSevent.chartImage.image}`)}
              alt={environmentPageData.sectionSevent.chartImage.alt}
              className="chart-image"
            /> */}
            <ChartThree />
          </div>
          <div className="space-50"></div>
          <div className="space-50"></div>
          <div className="space-50"></div>
          <Footer withBlogs={false} />
        </div>
      </div>
      </main>
  )
}

export default EnvironmentPage